export default "__VITE_ASSET__ada15395__"